import React, { useEffect,useState } from 'react';
import Homeiframe from "./homeiframe.jsx"


function Homeacc() {  
  const [name, setName] = useState('');
  const accountId = localStorage.getItem('userDetails');

  useEffect(()=>{
    if(accountId){
      const userDetails = JSON.parse(accountId);
      setName(userDetails.name);
    }
  },[])

  return (
    <div className="wbshor">
            <div className="login-header-wrap">
                <div className="login-header">
                    <div className="pagetitle">{name}</div>
                    <div className="button-wrapper">
                        {/* <button className="btntopright" id="optionsBtn"><p>&lt;</p></button> */}
                        <div className="options-popup" id="optionsPopup">
                            <button className="option-btn yellow">Filter ↓</button>
                            <button className="option-btn">Export report ↓</button>
                            <button className="option-btn">Hide Columns ↓</button>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="container">
              <Homeiframe/>
            </div>
        </div>
  
  );
}

export default Homeacc;
